import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface UpdateUseCreditsForMonthlyFeesArg {
    engagementId: number;
    useCreditsForMonthlyFees: boolean;
}

export const UpdateUseCreditsForMonthlyFees = createAsyncThunk(
    'timelines/updateUseCreditsForMonthlyFees',
    async (arg: UpdateUseCreditsForMonthlyFeesArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/Engagements/${arg.engagementId}/useCreditsForMonthlyFees/${arg.useCreditsForMonthlyFees}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to update the credits setting');
            }

            return {
                useCreditsForMonthlyFees: arg.useCreditsForMonthlyFees,
            };
        } catch (error) {
            createNotification(
                'An error occurred while updating the credits setting.',
                'error'
            );
            throw error;
        }
    }
);
